import React from "react";
import { fetchOrgSettings } from "../../actions/settings";
import Info from "../../components/info/Info";
import { wrapper } from "../../store";

export const getServerSideProps = wrapper.getServerSideProps((store) => async () => {
  await store.dispatch(fetchOrgSettings());
});

function Abitur() {
  const childNumAbitur = 1;

  return <Info childNum={childNumAbitur} pathnamePage="abitur" />;
}

export default Abitur;
